import { getColor, getSize } from '@lib/common';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  displayName: "comment-previewcomponent__Wrapper",
  componentId: "sc-u5cx2-0"
})(["background-color:", ";border-radius:", ";"], getColor('fillIntSubHover'), getSize('gap8'));
export var CommentPreview = function CommentPreview(_ref) {
  var value = _ref.value,
      label = _ref.label;
  if (!value) return /*#__PURE__*/_jsx(Wrapper, {
    children: label.noContent
  });
  return /*#__PURE__*/_jsx(Wrapper, {
    children: value
  });
};